import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-1 px-5 my-[30px]">
      <Typography variant="body2">
        © {new Date().getFullYear()} <b>EFEX</b>. {t('allRightsReserved')}
      </Typography>
      <Typography variant="body2">
        {t('disclaimer')}{' '}
        <a
          href="https://legal.efexpay.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Typography
            component="span"
            variant="body2"
            className="text-blue-500 hover:text-blue-800 inline"
          >
            {t('disclaimerHere')}
          </Typography>
        </a>
      </Typography>
    </div>
  );
};

export default Footer;
